module.exports = __webpack_public_path__ + "img/CAnnectCommunityBanner.0d6d2f87.svg";